import {
  executionReportExecTypeEnum,
  orderLegSideEnum,
} from '@/constants/order'

export function adjustOrderOpenClose(executionReportItems, itemIndex) {
  if (executionReportItems.length === 0) {
    return ''
  }

  if (executionReportItems.length > 2) {
    const nextExecutionReportIndex = itemIndex + 1
    if (executionReportItems[nextExecutionReportIndex].openClose === 'CLOSE') {
      return 'CLOSE'
    }
    return 'OPEN'
  } else if (
    Object.prototype.hasOwnProperty.call(executionReportItems[0], 'openClose')
  ) {
    if (executionReportItems[0].openClose === 'CLOSE') {
      return 'CLOSE'
    }
    return 'OPEN'
  }
}

export function getAverageOrderPrice(order) {
  function isFillExecutionReport(execReport) {
    return (
      execReport.execType === executionReportExecTypeEnum.FILL ||
      execReport.execType === executionReportExecTypeEnum.PARTIAL_FILL
    )
  }

  const execReportFills = order.executionReports.items.filter(
    isFillExecutionReport
  )

  if (execReportFills.length === 0) return

  function calcFillAvgPrice(execReport) {
    const lastPrice = execReport.lastShares ?? 0
    const lastQty = execReport.lastPx ?? 0
    const orderQty = execReport.orderQty ?? 1
    /* NOTE: Avg price = (Last price * Last quantity) / Order quantity */
    return (lastPrice * lastQty) / orderQty
  }

  const { buyFillsAvgPrice, sellFillsAvgPrice } = execReportFills.reduce(
    (acc, execReport) => {
      if (execReport.side === orderLegSideEnum.BUY)
        acc.buyFillsAvgPrice += calcFillAvgPrice(execReport)
      if (execReport.side === orderLegSideEnum.SELL)
        acc.sellFillsAvgPrice += calcFillAvgPrice(execReport)

      return acc
    },
    {
      buyFillsAvgPrice: 0,
      sellFillsAvgPrice: 0,
    }
  )

  return (buyFillsAvgPrice - sellFillsAvgPrice).toFixed(2)
}

export function findRemainingQty(order, val) {
  let remaining = 0,
    totalShares = 0,
    orderQty = order.quantity ? order.quantity : order.orderQty

  order.executionReports.items.forEach((execReport) => {
    if (execReport.lastShares != null) {
      var lastSharesVal = parseInt(execReport.lastShares)

      if (execReport.execType === 'PARTIAL_FILL') {
        lastSharesVal = lastSharesVal / order.userOrderLegs.length
      }

      remaining = remaining + lastSharesVal
    }
  })
  order.userOrderLegs.forEach((userOrderLeg) => {
    if (userOrderLeg.quantity != null) {
      totalShares =
        totalShares +
        Math.abs(parseInt(userOrderLeg.quantity)) * Math.abs(orderQty)
    }
  })

  let sharesLeft = totalShares - remaining

  if (val === 'filled') {
    sharesLeft = totalShares - sharesLeft
  }

  if (sharesLeft > orderQty) {
    sharesLeft = orderQty
  }

  return sharesLeft.toString() + '/' + orderQty
}
